import styled, { css } from 'styled-components';
import { ReactComponent as MeasureDistanceSvg } from '../../../assets/icons/fal-ruler.svg';
import { ReactComponent as MeasureAreaSvg } from '../../../assets/icons/fal-ruler-combined.svg';
import { ReactComponent as EllipsisStrokeSvg } from '../../../assets/icons/fal-ellipsis-stroke.svg';
import { ReactComponent as ObjectGroupSvg } from '../../../assets/icons/fal-object-group.svg';
import { ReactComponent as HandPointerSvg } from '../../../assets/icons/fal-hand-pointer.svg';
import { ReactComponent as CircleSvg } from '../../../assets/icons/fas-circle.svg';
import { ReactComponent as TriangleSvg } from '../../../assets/icons/fas-triangle.svg';
import { ReactComponent as DeleteSvg } from '../../../assets/icons/trash-can-solid.svg';
import { ReactComponent as TreeSvg } from '../../../assets/icons/fal-tree.svg';

const iconStyle = css`
  width: 21px;
  height: auto;
`;

const submenuIconStyle = css`
  width: 16px;
  height: auto;
  margin-right: 0.75rem;
`;

export const MeasureDistanceIcon = styled(MeasureDistanceSvg)`
  ${iconStyle};
`;

export const MeasureAreaIcon = styled(MeasureAreaSvg)`
  ${iconStyle};
`;

export const MillAreaIcon = styled(ObjectGroupSvg)`
  ${iconStyle};
`;

export const ForestAreaIcon = styled(ObjectGroupSvg)`
  ${iconStyle};
`;

export const ProfileGroundIcon = styled(EllipsisStrokeSvg)`
  ${iconStyle};
`;

export const SelectIcon = styled(HandPointerSvg)`
  ${iconStyle};
`;

export const SpruceIcon = styled(TriangleSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.brand_green} !important;
`;

export const PineIcon = styled(TriangleSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.brand_yellow} !important;
`;

export const BirchIcon = styled(TriangleSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.brand_blue} !important;
`;

export const OtherIcon = styled(TriangleSvg)`
  ${submenuIconStyle};
`;

export const DeadTreeIcon = styled(CircleSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.negative} !important;
`;

export const InfestedTreeIcon = styled(CircleSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.brand_yellow} !important;
`;

export const HealthyTreeIcon = styled(CircleSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.positive} !important;
`;
export const OtherHealthIcon = styled(CircleSvg)`
  ${submenuIconStyle};
`;

export const DeleteTreeIcon = styled(DeleteSvg)`
  ${submenuIconStyle};
  fill: ${({theme})=>theme.colors.negative} !important;
`;

export const TreeMenuIcon = styled(TreeSvg)`
  ${iconStyle};
`;

export const MenuItem = styled.div`
  position: relative;
  background-color: ${({theme, active}) => active ? theme.colors.information_bg : theme.colors.white};
  width: 3rem;
  height: 3rem;
  border: 1px solid rgba(17,139,214,.25);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.25rem;

  svg {
    fill: ${({theme, active }) => active ? theme.colors.brand_blue : theme.colors.text_dark};
  }

  &:before {
    position: absolute;
    transition: all ease 0.25s;
    bottom: 0;
    left: 0;
    display: block;
    height: 100%;
    width: 0;
    content: "";
    background-color: ${({theme}) => theme.colors.brand_blue};
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;

    &:before {
      width: 5px;
    }

    svg {
      fill: ${({theme}) => theme.colors.brand_blue};
    }
  }
`;

export const SubMenuItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.5rem;
  padding: 0.125rem 0.5rem;
  background-color: ${({theme, active}) => active ? theme.colors.information_bg : theme.colors.white};
  border: 1px solid ${({theme, active}) => active ? theme.colors.brand_blue : 'transparent'};

  &:hover {
    cursor: pointer;
    background-color: ${({theme}) => theme.colors.information_bg};
    color: ${({theme}) => theme.colors.brand_blue};
    border: 1px solid rgba(17,139,214,.25);
  }

  &:last-child {
    margin-bottom: 0;
  }

  span {
    font-size: 0.875rem;
  }
`;

export const MenuWrapper = styled.div`
  position: absolute;
  top: 53px;
  display: flex;
  flex-direction: column;
  z-index: 1;
  left: 8px;

  ${MenuItem} {
    width: 3rem;
  }
`;